import {CONSONANT_VOWEL_PAIRS_SILENT_NG} from "../../../SubjectData/Phonetics/ConsonantVowelPairs/ConsonantVowelPairs_silentng.js";
import "../../Deck.css";
import FlashcardInterface from "../../Flashcard_Interface.js";
import HeaderNav from "../../../Components/Header/Header_Nav/Header_Nav.js";



export default function CONSONANT_VOWEL_PAIRS_SILENT_NG_DECK() {


 return(
 
     <>
        <HeaderNav GoBack_to={"/ConsonantVowelPairsNav"}/>
        <FlashcardInterface deckData={CONSONANT_VOWEL_PAIRS_SILENT_NG} title="Consonant-Vowel Pairs: ㅇ (silent/ng)" />
     </>
);}